import React from "react"
import {FieldViewProps} from "../../../../render/view"

export default function FieldDropdown_ViewGlist(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    const option = props.field._getOption(value)
    if (!option) return null

    const optionColor = _.get(option, 'color', null)
    const classes = Classes("ui5-txt-less-important-small fl-ac m-t-4 m-b-4", props.className)

    if (optionColor) {
        const pillClasses = Classes("ui5-pillbox s22", "gd-c-bgp-"+optionColor, "gd-c-pale-border-"+optionColor, props.className)
        return (
            <div className={pillClasses}>
                {option.label}
            </div>
        )
    }

    return (
        <div className={classes}>
            {_.get(props.field.components, 'ValueIcon', false)}
            <span className="txt-truncate">{option.label}</span>
        </div>
    )
}
